import React, { useState, useEffect } from 'react';
import PageTitle from '../../module/pageTitle';
import LabelInput from '../../Component/labelInput';
import DropDown from '../../Component/dropdown';
import { Submitbtn } from '../../Component';
import TextEditor from '../../Component/textEditor';
import { addUpdateKRAKPI, getCompanyList, getDepartmentList, getSubDepartmentList } from './superAdminSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';

const KRAKPI = () => {
    const dispatch = useDispatch<AppDispatch>()
    const [companyList, setCompanyList] = useState<any>([]);
    const [companyName, setCompanyName] = useState<any>();
    const [departmentList, setDepartmentList] = useState<any>([]);
    const [departmentName, setDepartmentName] = useState<any>();
    const [subDepartmentList, setSubDepartmentList] = useState<any>([]);
    const [subDepartmentName, setSubDepartmentName] = useState<any>();
    const [KRA, setKRA] = useState<any>();
    const [KPI, setKPI] = useState<any>();

    useEffect(() => {
        dispatch(getCompanyList({
            callback: (res: any) => {
                setCompanyList(res?.data);
            },
            errorCallback: () => { }
        }));
        dispatch(getDepartmentList({
            callback: (res: any) => {
                setDepartmentList(res?.data);
            },
            errorCallback: () => { }
        }));
    }, []);

    const onChangeContent = (val: any, key: string) => {

        if (key === 'company') setCompanyName(val);
        else if (key === 'department') {
            setDepartmentName(val);
            dispatch(getSubDepartmentList({
                id: val?._id,
                callback: (res: any) => {
                    setSubDepartmentList(res?.data);
                },
                errorCallback: () => { }
            }));
        }
        else if (key === 'subDepartment') setSubDepartmentName(val);
        else if (key === 'KRA') setKRA(val);
        else if (key === 'KPI') setKPI(val);
    }
    const handelSubmit = (e: any) => {
        e.preventDefault();
        const payload = {
            companyId: companyName?._id,
            departmentId: departmentName?._id,
            subDepartmentId: subDepartmentName?._id,
            kra: KRA,
            kpi: KPI
        };
        dispatch(addUpdateKRAKPI({
            params: payload,
            callback: (res: any) => {
                if (res) {
                }
            },
            errorCallback: () => { },
        }))
    };
    return (
        <div className='panel-content'>
            <div className='mb-4'>
                <PageTitle name={"KRA / KPI"}
                    breadCrumb={""}
                    isEditMode={""}
                    cancelEdit={() => ('')} />
            </div>
            <div className='formDiv'>
                <div className='bxshadow p-2 borderRadius mb-4'>
                    <form onSubmit={handelSubmit}>
                        <div className="row">
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Company"} />
                                <DropDown
                                    labelName={"Select Company"}
                                    setInputText={(value: any) => onChangeContent(value, "company")}
                                    options={companyList}
                                    value={companyName}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Department"} />
                                <DropDown
                                    labelName={"Select Department"}
                                    setInputText={(value: any) => onChangeContent(value, "department")}
                                    options={departmentList}
                                    value={departmentName}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Sub Department"} />
                                <DropDown
                                    labelName={"Select Sub Department"}
                                    setInputText={(value: any) => onChangeContent(value, "subDepartment")}
                                    options={subDepartmentList}
                                    value={subDepartmentName}
                                />
                            </div>
                            <div className='col-md-6 mb-3'>
                                <LabelInput labelName={"KRA"} />
                                <TextEditor
                                    onChange={(value: any) => (onChangeContent(value, "KRA"))}
                                    value={KRA} />
                            </div>
                            <div className='col-md-6 mb-3'>
                                <LabelInput labelName={"KPI"} />
                                <TextEditor
                                    onChange={(value: any) => (onChangeContent(value, "KPI"))}
                                    value={KPI} />
                            </div>
                            <div className='col-md-2 mx-auto'>
                                <Submitbtn name={"Save"} disabled={false} />
                            </div>
                        </div>
                    </form >
                </div>
            </div>
        </div>
    );
}

export default KRAKPI;